import type { LinkPreview, LinkPreviewCache } from './types';
import { ProxyMethod } from './types/enums';
import ProxyService from './Proxy';
import config from './config';

export default class LinkPreviewService {
  public proxy: ProxyService;
  public cache: LinkPreviewCache = new Map<string, LinkPreview>();

  readonly route = config.urls.unfurl;
  readonly server = config.linkpreview.server;

  constructor(proxy: ProxyService) {
    this.proxy = proxy;
  }

  public async get(url: string): Promise<LinkPreview> {
    if (!this.cache.has(url)) {
      let linkPreview: LinkPreview = { url, title: '', description: '', images: [] }
      
      try {
        const ajaxParams = {
          type: ProxyMethod.POST,
          url: `${this.server}/${this.route}`,
          data: { url },
        };

        linkPreview = (await this.proxy.ajax(ajaxParams)) as LinkPreview;
      } catch (error) {
        linkPreview.title = this.getHostFromUrl(url);
      }

      this.cache.set(url, linkPreview);
    }

    return this.cache.get(url) as LinkPreview;
  }

  private getHostFromUrl(url: string): string {
    if (typeof URL === 'function') {
      return new URL(url).hostname;
    }

    const match = url.match(/^(?:https?:\/\/)?([^\/]+)/);
    return match ? match[1] : url;
  }
}
